import React, { useState } from "react";
import { Card } from "reactstrap";
import { useParams } from "react-router-dom";
import { useForm } from "react-hook-form";

import { BlockBetween, BlockTitle } from "../../Component";
import DropzoneInput from "../../input/dropzone/DropzoneInput";
import UpdatableText from "../../shared/UpdatabaleText";
import BlockUpdateButton from "../../button/BlockUpdateButton";

import { useBeManualFetcher } from "../../../hooks/useBeManualFetcher";
import newsService from "../../../services/newsService";
import { IMAGE_KEYS } from "../../../utilities/constants";
import { imageToFileConvert } from "../../../utilities/imageUtils";
import EventEmitter, { EVENT_TOPICS } from "../../../utilities/eventUtils";

const NewsImagesBlock = ({ images: existingImages }) => {
  const { handleSubmit } = useForm();
  const { newsId } = useParams();
  const [onFetch] = useBeManualFetcher();

  const [hasEditClicked, setHasEditClicked] = useState(false);
  const [images, setImages] = useState([]);

  function handleOnEditClicked() {
    setHasEditClicked((prev) => !prev);
  }

  async function onFormSubmit() {
    let newFormData = new FormData();
    newFormData.append("newsId", newsId);

    images.forEach((img, index) => {
      newFormData.append(
        "files",
        imageToFileConvert(img, `${IMAGE_KEYS.COVER_IMAGE}_${index}`)
      );
    });

    return await onFetch({
      action: () => newsService.uploadNewsFiles(newFormData),
      onLoad: (response) => {
        EventEmitter.emit(EVENT_TOPICS.ON_NEWS_UPDATED, {
          updatedNews: response,
        });

        setHasEditClicked(false);
      },
      successMessage: "News updated successfully",
    });
  }

  return (
    <Card className="card-inner">
      <form onSubmit={handleSubmit(onFormSubmit)}>
        <BlockBetween>
          <BlockTitle tag="h5">Images</BlockTitle>
          <BlockUpdateButton
            hasEditClicked={hasEditClicked}
            handleOnEditClicked={handleOnEditClicked}
          />
        </BlockBetween>
        <div className="profile-ud-list position-relative mt-3">
          <div className="profile-ud-item">
            <UpdatableText
              title="Images"
              defaultValue={
                <div className="d-flex flex-wrap" style={{ gap: 8 }}>
                  {existingImages?.length > 0
                    ? existingImages.map((src, i) => (
                        <img
                          key={i}
                          className="w-40 h-40"
                          src={src}
                          alt={`image-${i}`}
                        />
                      ))
                    : "-"}
                </div>
              }
              editableValueComponent={
                <DropzoneInput
                  files={images}
                  setFiles={setImages}
                  multiple
                />
              }
              onEditClicked={hasEditClicked}
            />
          </div>
        </div>
      </form>
    </Card>
  );
};

export default NewsImagesBlock;
